import { z } from 'zod';

/** Fase 5: comprovante de saída, balcão e convite de avaliação. */

export const exitCheckSchema = z.object({ code: z.string().trim().min(4, 'Digite o código').max(40) });
export const exitConfirmSchema = z.object({ giftDelivered: z.boolean().default(false) });
export const exitSettingsSchema = z.object({
  giftEnabled: z.boolean(),
  giftNote: z
    .string()
    .trim()
    .max(80)
    .transform((v) => (v === '' ? null : v))
    .nullable()
    .optional(),
});

/** Estados exibidos ao balconista (texto do prompt mestre). */
export const EXIT_STATE = {
  PAID: { title: 'CONTA PAGA', subtitle: 'Saída autorizada', tone: 'success' },
  PENDING: { title: 'CONTA PENDENTE', subtitle: 'Há valor em aberto', tone: 'danger' },
  PROCESSING: { title: 'PAGAMENTO EM PROCESSAMENTO', subtitle: 'Aguarde a confirmação', tone: 'warning' },
  INVALID: { title: 'COMPROVANTE INVÁLIDO', subtitle: 'Verifique manualmente', tone: 'danger' },
  ALREADY_VALIDATED: { title: 'COMPROVANTE JÁ VALIDADO', subtitle: 'Evite reutilização indevida', tone: 'warning' },
} as const;
export type ExitState = keyof typeof EXIT_STATE;

/**
 * Textos do brinde no comprovante de saída, definidos pelo dono do Garlic (21/10/2026).
 * ATENÇÃO: pedir avaliação em troca de brinde contraria a política de conteúdo do Google Maps (avaliações
 * incentivadas) — o Google pode remover avaliações e penalizar o perfil do restaurante. Decisão de negócio
 * tomada ciente do risco; ver docs/SEGURANCA.md. O sistema em si não verifica se houve avaliação.
 */
export const GIFT_COPY = {
  /** Com link de avaliação configurado pelo restaurante. */
  title: 'VOCÊ GANHOU UM BRINDE!',
  callToAction: 'NOS AVALIE NO GOOGLE E MOSTRE NA SAÍDA!',
  button: 'AVALIAR',
  thanks: 'Obrigado! Mostre sua avaliação e este comprovante ao balconista na saída.',
  /** Quem pagou só uma parte da conta (ainda sem comprovante de saída). */
  thanksPartial: 'Obrigado! Mostre sua avaliação ao balconista na saída.',
  /** Sem link de avaliação configurado: só o brinde. */
  noReviewText: 'Mostre este comprovante ao balconista na saída. Volte sempre!',
} as const;
